import { Col, Row } from "react-bootstrap";
import {
    DraftOrderBusinessContainer,
    OrderDeliveredGridContainer,
    OrderStatusGridContainer,
} from "../../containers";
import { useIntl } from "react-intl";

const LeadBusinessManagerDashboard = () => {
    const { formatMessage } = useIntl();
    return (
        <div className="dashboardContainer businessManagerDashboardContainer">
            <DraftOrderBusinessContainer />
            <Row className="mt-32 h-95">
                <Col>
                    <h2>{formatMessage({ id: "dashboard.order.lastDay.title" })}</h2>
                    <OrderDeliveredGridContainer />
                </Col>
                <Col>
                    <h2>{formatMessage({ id: "dashboard.order.status.title" })}</h2>
                    <OrderStatusGridContainer />
                </Col>
            </Row>
        </div>
    );
};

export default LeadBusinessManagerDashboard;
